//////////////////////////////////////////////////////////////////////////////
//
//  Exercise Video API
//
//  작성자: MediInStep Team
//  생성일: 2025-12-24
//
//  설명: 운동 영상 관련 API 정의
//
//////////////////////////////////////////////////////////////////////////////

import { ApiGroup } from "../types/ApiTypes"

/**
 * 운동 영상 관련 API
 */
const ExerciseVideoAPI: ApiGroup = {
    pagedList: {
        title: "운동 영상 목록 조회",
        url: "/ExerciseVideo/PagedList",
        method: "POST",
        paramz: {},
    },
    list: {
        title: "전체 운동 영상 목록 조회",
        url: "/ExerciseVideo/List",
        method: "GET",
        paramz: {},
    },
    getById: {
        title: "운동 영상 상세 조회",
        url: "/ExerciseVideo/{id}",
        method: "GET",
        paramz: {},
        pathParams: ["id"],
    },
    create: {
        title: "운동 영상 등록",
        url: "/ExerciseVideo",
        method: "POST",
        paramz: {},
    },
    update: {
        title: "운동 영상 수정",
        url: "/ExerciseVideo/{id}",
        method: "PUT",
        paramz: {},
        pathParams: ["id"],
    },
    delete: {
        title: "운동 영상 삭제",
        url: "/ExerciseVideo/{id}",
        method: "DELETE",
        paramz: {},
        pathParams: ["id"],
    },
    updateDisplayOrder: {
        title: "운동 영상 표시 순서 변경",
        url: "/ExerciseVideo/UpdateDisplayOrder",
        method: "PUT",
        paramz: {},
    },
}

export default ExerciseVideoAPI
